import { KanbanPusherAddLane, KanbanPusherMoveCard, KanbanPusherType } from "./kanbanPusherTypes"

export default class CacheKanbanOperations {
    #moveCardOp: KanbanPusherMoveCard[] = []
    #addLaneOp: KanbanPusherAddLane[] = []

    constructor() {
    }

    clear() {
        this.#moveCardOp = []
        this.#addLaneOp = []
    }

    addMoveOp(op: KanbanPusherMoveCard) {
        this.#moveCardOp.push(op)
    }

    addLaneOp(op: KanbanPusherAddLane) {
        this.#addLaneOp.push(op)
    }

    isWasMoveOp(data: KanbanPusherMoveCard) {
        return !!this.#moveCardOp.find(x => x.data.docId === data.data.docId && x.data.sourceLane === data.data.sourceLane && x.data.targetLane === data.data.targetLane)
    }

    isWasAddLaneOp(data: KanbanPusherAddLane) {
        return !!this.#addLaneOp.find(x => x.data.id === data.data.id)
    }

    isWasAddOp() {
        return false
    }

    isWasOperation(action: KanbanPusherType, data: any) {
        return true
        switch (action) {
            case 'MoveCard':
                return this.isWasMoveOp(data)
            case 'NewLane':
                return this.isWasAddLaneOp(data)
            case 'AddCard':
                return this.isWasAddOp()
            default:
                return false;
        }
    }
}

export const cacheKanbanOperations = new CacheKanbanOperations()